export const CONTENT_STACK = 'comcontentstackas';
export const AMSHOP = 'comamshopws';
export const AMSHOP_PILOT = 'comamshoppilotws';
export const BLOCKS_PRIVILEGE = 'comblocksprivilegesas';
export const PRODUCT = 'comproductas';
export const SUBSCRIPTION = 'comsubscriptionas';
export const MYSHOP = 'commyshopas';
export const SHAREBAR = 'comsharebaras';
export const CATEGORY = 'comcategoryas';
export const LIST = 'comlistas';
export const SEARCH = 'comsearchas';
